export default (r, header) =>
    r.headers ? r.headers.get(header) : r.getResponseHeader(header)
